import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_PAGE](state, payload) {
    this._vm.$log.debug('ADD_PAGE: ', payload);
    payload.site.pages.push(payload.page);
  },
};

const actions = {
  async addPage({ commit, rootState }, page) {
    const p = {
      site: rootState.Websites.currentSite,
      page,
    };
    commit(types.ADD_PAGE, p);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/add-page/vuex.js